const Dot = ({ clazz }) => {
    return <div className={clazz}></div>;
};

export default Dot;
